import { IconWrapper } from '../runtime';
export default IconWrapper('eye_close', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none",
      "stroke-width": props.strokeWidth
    }
  }, [h("g", {
    "attrs": {
      "id": "group-0",
      "stroke": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333',
      "fill": props.colors && typeof props.colors !== 'string' && props.colors[0] || typeof props.colors === 'string' && props.colors || '#333333'
    }
  }, [h("path", {
    "attrs": {
      "d": "M2 6.3031C1.30165 7.22612 1 8 1 8C1 8 2.85149 12.75 8 12.75C8.17025 12.75 8.3369 12.7448 8.5 12.7348M7.5 3.26524C7.6631 3.25519 7.82975 3.25 8 3.25C13.1485 3.25 15 8 15 8C15 8 14.6984 8.77388 14 9.6969M3 3L13 13",
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  })])]);
});